/**
 * Format for internal identifiers such as infrastructure resource kinds and binding roles.
 * Only the format is fixed; the set of values is deliberately open (no invented vocabulary).
 * Mirrors the database CHECK constraints added in migration 0002.
 */
export const IDENTIFIER_PATTERN = /^[a-z][a-z0-9_]{0,62}$/;

export function isIdentifier(value: string): boolean {
  return IDENTIFIER_PATTERN.test(value);
}
